
export class Notiz {
    constructor(
        public id = '',
        public archiv = false,
        public clientId = '',
        public leadId = '',
        public text = '',
        public pinned = false,
        public important = false,
        public createdAt = '',
        public createdBy = '',
        public createdAtUnix = 0,
        public updatedAt = '',
        public updatedAtUnix = 0,
    ) {
    }
}
